export default [
	{
		path: 'account/manage-subscription/cancel-reason',
		name: 'manage-subscription-cancel-reason',
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/manage-subscription/CancelReason.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
			hideProgress: true
		}
	},

	{
		path: 'account/manage-subscription/try-again-in-the-future',
		name: 'manage-subscription-try-again-in-the-future',
		component: () =>
			import(
				/* webpackChunkName: "manage-subscription" */
				'@/views/account/manage-subscription/TryAgainInTheFuture.vue'
			),
		meta: {
			requiresAuth: true,
			requiresUser: true,
			hideProgress: true
		}
	},

	{
		path: 'account/manage-subscription/feedback',
		name: 'manage-subscription-feedback',
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/manage-subscription/Feedback.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
			hideProgress: true
		}
	},

	{
		path: 'account/manage-subscription/result',
		name: 'manage-subscription-result',
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/manage-subscription/Result.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
			hideProgress: true,
			hideHeader: true
		}
	},

	{
		path: 'account/manage-subscription/offer-creating',
		name: 'manage-subscription-offer-creating',
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/manage-subscription/OfferCreating.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
			hideProgress: true
		}
	},

	{
		path: 'account/manage-subscription/offer',
		name: 'manage-subscription-offer',
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/manage-subscription/Offer.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
			hideProgress: true,
			requiresUserFlags: true
		}
	},

	{
		path: 'account/manage-subscription/assessment-offer',
		name: 'manage-subscription-assessment-offer',
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/manage-subscription/AssessmentOffer.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
			hideProgress: true
		}
	},
	{
		path: 'account/plan-management',
		name: 'plan-management',
		component: () =>
			import(/* webpackChunkName: "plan-management" */ '@/views/account/manage-subscription/PlanManagement.vue'),
		meta: {
			requiresUserFlags: true,
			requiresAuth: true,
			requiresUser: true,
			hideProgress: true
		}
	},
	{
		path: 'account/plan-management/pause-subscription',
		name: 'pause-subscription',
		component: () =>
			import(/* webpackChunkName: "plan-management" */ '@/views/account/manage-subscription/PauseSubscription.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
			hideProgress: true
		}
	}
]
